<template>
  <b-modal
    id="MapSettingsMenu"
    content-class="menu-bg-blue-transparent-modal"
    title="Map Settings"
    hide-footer
    @show="getMapSettings()"
  >
    <b-container fluid>
      <!-- Default Extent -->
      <b-row class="p-1 m-3">
        <label for="extents" class="col-sm-4 col-form-label">
          Default Extent
        </label>
        <b-col class="col-sm-8">
          <b-form-select
            id="extents"
            v-model="selectedExtent"
            style="text-shadow: 0px 0px" 
          >
            <b-form-select-option 
              v-for="extent in extents" 
              :value="extent" 
              :key="extent.id"
            >{{ extent.extent_description }}</b-form-select-option>
          </b-form-select>
          <!-- <multiselect
            id="extents"
            v-model="selectedExtent"
            placeholder=""
            style="text-shadow: 0px 0px"
            :deselectLabel="null"
            :options="extents.map(extent => extent.extent_description)"
            :selectLabel="null"
          ></multiselect> -->
        </b-col>
      </b-row>
      <!-- Save button -->
      <b-row class="p-3">
        <b-col class="text-center">
          <b-button
            variant="primary"
            size="lg"
            type="submit"
            @click="saveMapSettings()"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
/* Add space between cards for mobile view */
@media (max-width: 470px) {
  .xs-spacing {
    padding-top: 2rem;
  }
}

@media (min-width: 768px) {
  .modal-width {
    width: 65%;
    max-width: 700px;
  }
}
</style>

<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import {get as projGet, transform, transformExtent} from 'ol/proj'
import View from 'ol/View'
export default {
  name: 'MMP_MapSettings',
  components: {Multiselect},
  props: ['isUshrUser', 'userOrg'],
  data() {
    return {
      mapLayers: [],
      mapLayersLoaded: false,
      possibleExtents: ['North America', 'Europe', 'Middle East', 'Japan'],
      extents: [],
      selectedExtent: {},
      selectedLayers: undefined
    }
  },
  watch: {
    selectedExtent: function (newValue) {
      console.log(newValue)
    }
  },
  methods: {
    getExtent() {
      let extent = JSON.parse(sessionStorage.getItem('Extent'))
      if (extent != null) {
        console.log(extent)
        this.selectedExtent = extent
      }
    },
    changeExtent() {
      let extentValues = []
      let extentCenter = []
      console.log(this.selectedExtent)
      /* Need to convert the string into array of numbers
      for passing to the transformExtent function. */
      this.selectedExtent.extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      this.selectedExtent.extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })
      let view = new View({
        extent: new transformExtent(
          extentValues,
          new projGet('EPSG:4326'),
          new projGet('EPSG:3857')
        ),
        center: new transform(
          extentCenter,
          new projGet('EPSG:4326'),
          new projGet('EPSG:3857')
        ),
        constrainOnlyCenter: true,
        zoom: 5,
        minZoom: 3,
        multiWorld: true
      })
      this.$emit('extentChanged', {
        selectedExtent: this.selectedExtent.extent_description,
        view: view
      })

      this.$bvModal.hide('MapSettingsMenu')
    },
    getExtents() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/users/getExtents', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              company_id: this.userOrg
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getExtents API Call Error: ' + content.errors)
            } else {
              this.extents = content.filter(extent => !(['South Korea', 'Continental United States'].includes(extent.extent_description))) // filter out these two if returned
              console.log(this.extents)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async getMapSettings() {
      await this.getExtent()
      await this.getView()
      await this.$nextTick()
      if (this.userOrg) {
        await this.getExtents()
      }
    },
    getView() {
      let layers = JSON.parse(sessionStorage.getItem('View'))
      if (layers != null) {
        this.selectedLayers = layers
      }
    },
    loadMapLayers() {
      // If statement prevents pushing the same layers multiple times
      if (!this.mapLayersLoaded) {
        for (let layer in this.$parent.ushrLayersButtonsCtrl) {
          this.mapLayers.push(this.$parent.ushrLayersButtonsCtrl[layer].name)
        }
        this.mapLayersLoaded = true
      }
    },
    async saveMapSettings () {
      if (this.selectedExtent != null) {
        sessionStorage.setItem('Extent', JSON.stringify(this.selectedExtent))
      }
      await this.changeExtent()
      this.$bvToast.toast('Map settings submitted.', {
        autoHideDelay: 5000,
        variant: 'success',
        title: 'Status',
        solid: true,
        toaster: 'b-toaster-top-center'
      })
    }
  },
  mounted() {
    this.getMapSettings()
  } 
}
</script>
